import { compose, mdsWidget } from 'dojo/_base/declare';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import template from './templates/AttachmentUpload.html?raw';
import domConstruct from 'dojo/dom-construct';
import domAttr from 'dojo/dom-attr';
import domClass from 'dojo/dom-class';
import lang from 'dojo/_base/lang';
// NOTE (JS2TS): dropped dead dojo deps (dom-style, _base/connect, on).

class AttachmentUpload extends compose(_WidgetBaseSP) {
    [key: string]: any;

    templateString: any = template;

    item: any = null;
    submitCallback: any = null;
    _fileToUpload: any = null;
    _rawdata: any = null;
    startup(): void {

        domClass.remove(this.formContainer, "w3-hide");
    }

    showSpinner(): void {
        //spinners.global().spin(document.getElementById('modalSpinner'));
        //domClass.remove(this.modalSpinnerContainer, "w3-hide");
        this.StandbyStart();
    }

    stopSpinner(): void {
        //spinners.global().stop();
        //domClass.add(this.modalSpinnerContainer, "w3-hide");
        this.StandbyStop();
    }

    _onClick_Upload(evt: any): void {
        this.resetMessage();
        this.showSpinner();

        if (this._fileToUpload == null) {
            this.setMessage("Keine Datei zum Hochladen gewählt");
            return;
        }

        this._readFileContent();
    }

    _uploadFile(): void {

        var fileData = {
            "Base64Content": this._rawdata,
            "FileName": this._fileToUpload.name,
            "FileType": this._fileToUpload.type,
            "FileSize": this._fileToUpload.size,
            "LastModified": this._fileToUpload.lastModified
        };
        //console.debug("Filesize:", this._fileToUpload.size);
        var maxSizeMB = 20;
        if (fileData.FileSize > maxSizeMB * 1024 * 1024) {
            this._onUploadFileError({ Message: "Die Datei ist zu groß für den Upload. Es sind maximal " + maxSizeMB + "MB erlaubt." });
            return;
        }

        var jsonData = {
            EntityClass: "ev_projects", // evtl flexibel machen und irgendwie aus this.item auslesen oder so?
            EntityID: this.item.ref_ev_project,
            note: this.notes.value,
            data: fileData
        };

        var url = window.appRoot + "SOV/AttachmentsFileUpload";
        //var url = window.appRoot + "Orchestra/GetOtherMusiciansDispo";
        console.log("uploadfile");//, JSON.stringify(jsonData));

        this.RequestManager.post(
            url,
            {
                jsonData: JSON.stringify(jsonData)
            },
            lang.hitch(this, "_onUploadFileResponse"),
            lang.hitch(this, "_onUploadFileError"),
            false // sync
        );

    }

    _onUploadFileResponse(state: any): void {
        console.log("_onUploadFileResponse", state);
        this.stopSpinner();

        if (typeof (this.submitCallback) == "function") {
            this.submitCallback();
        }
    }

    _onUploadFileError(error: any): void {
        this.stopSpinner();
        console.log("_onUploadFileError", error);
        this.setMessage(error.Message);
    }

    _onChange_FileInput(evt: any): void {
        console.log("_onChange_FileInput", evt);
        this.resetMessage();

        this._fileToUpload = evt.target.files[0];
        //domAttr.set(this.fileSelectLabel, "innerHTML", this._fileToUpload.name);

        if (this._fileToUpload != null) {
            domClass.remove(this.actionContainer, "w3-hide");
        } else {
            domClass.add(this.actionContainer, "w3-hide");
        }
    }

    _readFileContent(): any {
        var file = this._fileToUpload
        if (file == null) {
            return false;
        }

        var reader = new FileReader();

        //  hier wird der FileReader jedes File lesen und an Load bzw Error-Funktion übergeben
        //
        reader.onload = lang.hitch(this, "_onFileReader_Load", reader);
        reader.onerror = lang.hitch(this, "_onFileReader_Error");

        reader.readAsDataURL(file);
        console.log("reader liest datei ein...", reader, file);
        return true; // zurückmelden, dass der upload-vorgang angeworfen wurde. hat aber noch keine aussage darüber ob er erfolgreich beendet wurde!
    }

    _onFileReader_Load(reader: any): void {
        //  Der FileReader konnte das File ohne Fehler lesen
        //
        var Base64Content = reader.result;
        this._rawdata = Base64Content;
        this._uploadFile();
    }

    _onFileReader_Error(error: any): void {
        console.log("_onFileReader_Error", error);
    }



    setMessage(message: any): void {
        //domClass.add(this.employmentSelectContainer, "w3-hide");
        domAttr.set(this.messageNode, "innerHTML", message);

        //this._timeoutFct = setTimeout(lang.hitch(this, "resetMessage"), 4000);
    }

    resetMessage(): void {
        //domClass.remove(this.employmentSelectContainer, "w3-hide");
        domConstruct.empty(this.messageNode);
    }

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any);
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }

}
AttachmentUpload.prototype.declaredClass = 'WidgetCollection.SOV.legacy.Main.AttachmentUpload';

export default mdsWidget(AttachmentUpload);
